import { render, staticRenderFns } from "./CompanyOnboardingSideMenu.vue?vue&type=template&id=a2a3d59e&scoped=true"
import script from "./CompanyOnboardingSideMenu.vue?vue&type=script&lang=js"
export * from "./CompanyOnboardingSideMenu.vue?vue&type=script&lang=js"
import style0 from "./CompanyOnboardingSideMenu.vue?vue&type=style&index=0&id=a2a3d59e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a3d59e",
  null
  
)

export default component.exports